<template>
  <div class="faq-area with-top-border ptb-100">
    <div class="container">
      <div class="row m-0 align-items-end">
        <div class="col-lg-6 col-md-12 p-0">
          <div class="faq-accordion">
            <div class="section-title">
              <span class="sub-title">Perguntas Frequentes</span>
              <h2>Dedicados a ajudar com tudo que as pessoas precisam</h2>
            </div>
            <div class="accordion" id="faqAccordion">
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Como funciona o processo de desenvolvimento?
                </button>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Seguimos uma metodologia ágil com etapas bem definidas: análise de requisitos, planejamento, desenvolvimento, testes e entrega. Mantemos comunicação constante durante todo o processo.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Qual é o prazo médio para desenvolver um projeto?
                </button>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>O prazo varia conforme a complexidade do projeto. Projetos simples levam de 2-4 semanas, enquanto sistemas mais complexos podem levar de 2-6 meses. Sempre fornecemos um cronograma detalhado.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Vocês oferecem suporte após a entrega?
                </button>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! Oferecemos garantia de 3 meses para correção de bugs e suporte técnico contínuo com planos de manutenção personalizados para cada cliente.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Quais tecnologias vocês utilizam?
                </button>
                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Trabalhamos com as tecnologias mais modernas: Vue.js, React, Laravel, Node.js, Python, MySQL, PostgreSQL, MongoDB e soluções em nuvem como AWS e Google Cloud.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 p-0">
          <div class="faq-image" data-aos="fade-up">
            <img src="../../assets/images/faq1.png" alt="faq-image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq'
}
</script>